import {removeUndefinedLocaleResources} from 'sanity'

export default removeUndefinedLocaleResources({
  /** Browse button text */
  'feedback.attachment.browse': undefined, // 'Browse'
  /** Drop zone text for image attachment */
  'feedback.attachment.drop-zone': undefined, // 'Drag or paste file here'
  /** Error shown when attached image exceeds size limit */
  'feedback.attachment.error.size': undefined, // 'Image must be under 20 MB'
  /** Label for the image attachment section */
  'feedback.attachment.label': undefined, // 'Attach an image'
  /** Remove attached image button text */
  'feedback.attachment.remove': undefined, // 'Remove'
  /** Cancel button text */
  'feedback.cancel': undefined, // 'Cancel'
  /** Consent disclaimer shown when the user agrees to follow up */
  'feedback.consent.disclaimer': undefined, // 'We\'d love to learn more. Selecting yes shares your name and email with the Sanity team.'
  /** Label for the contact consent toggle */
  'feedback.consent.label': undefined, // 'Can we follow up with you about this feedback?'
  /** Consent toggle: no */
  'feedback.consent.no': undefined, // 'No'
  /** Consent toggle: yes */
  'feedback.consent.yes': undefined, // 'Yes'
  /** Title of the feedback dialog */
  'feedback.dialog.title': undefined, // 'Share feedback with Sanity'
  /** Toast message after failed submission */
  'feedback.error': undefined, // 'Failed to submit feedback with error'
  /** Label for "send feedback" in the help resources menu */
  'feedback.menu-item': undefined, // 'Send feedback'
  /** Label for the message field */
  'feedback.message.label': undefined, // 'What is working? What could be better?'
  /** Placeholder for the message field */
  'feedback.message.placeholder': undefined, // 'Describe your issue or request...'
  /** Sentiment option: happy */
  'feedback.sentiment.happy': undefined, // 'Easy'
  /** Label for the sentiment question */
  'feedback.sentiment.label': undefined, // 'How easy or difficult is Sanity to use?'
  /** Sentiment option: neutral */
  'feedback.sentiment.neutral': undefined, // 'Not sure'
  /** Sentiment option: unhappy */
  'feedback.sentiment.unhappy': undefined, // 'Difficult'
  /** Submit button text */
  'feedback.submit': undefined, // 'Send feedback'
  /** Toast message after successful submission */
  'feedback.success': undefined, // 'Feedback submitted, thank you!'
})
